export enum DslrChartFields {
  oralConditionRecord = 'oralConditionRecord',
  mistakesAndCompensation = 'mistakesAndCompensation',
}

export const DslrChartFormDefaultValues = {
  [DslrChartFields.oralConditionRecord]: '',
  [DslrChartFields.mistakesAndCompensation]: '',
};

export const AttachmentFilesDefaultValues = {
  0: null,
  1: null,
  2: null,
  3: null,
  4: null,
};
